<a (click)="onLinkClick()" class="notification-link">{{linkText}}</a>
